import { useAuth } from '../../contexts/AuthContext'
import { RectangleStackIcon, ChartBarIcon, ClockIcon } from '@heroicons/react/24/outline';
import StatCard from "../../components/StatCard";
import ClassPerformanceChart from "../../components/ClassPerformanceChart";
import MilestoneCompletion from "../../components/MilestoneCompletion";
import StudentApplicationTable from "../../components/StudentApplicationTable";
import { performanceData, statsData, milestones, applications, applicationTableHeaders } from "../../components/StudentDasbordData";
import FeedbackForm from '../../components/FeedbackForm';
import { useEffect, useState } from 'react';
import ClassPerformanceTwoLineChart from '../../components/ClassPerformanceTwoLineChart';

function StudentDashboard() {
  const { user, getAllDashboardData } = useAuth()
  const [openFeedBackForm, setOpenFeedBackform] = useState(false)
  const [dashboardPerformanceTrend, setDashboardPerformanceTrend] = useState([])
  const [dashboardPerformanceSummary, setDashboardPerformanceSummary] = useState([])
  const [dashboardMyApplications, setDashboardMyApplications] = useState([])
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    getDashboardData()
  }, [])


  const getDashboardData = async () => {
    try {
      setLoader(true)
      const response = await getAllDashboardData()
      if (response?.success == true) {
        setLoader(false)
        setDashboardPerformanceTrend(response?.data?.score)
        setDashboardPerformanceSummary(response?.data?.performanceSummary)
        setDashboardMyApplications(response?.data?.applications)
      } else {
        setLoader(false)
        setDashboardPerformanceTrend([])
        setDashboardPerformanceSummary([])
        setDashboardMyApplications([])
      }
    } catch (error) {
      setLoader(false)
      console.error('Error fetching dashboard data:', error)
    }
  }

  return (
    <div className="space-y-6 p-4">
      {/* <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Welcome back, {user?.firstName}!
        </h1>
        <p className="text-gray-600">Here's your learning progress overview</p>
      </div> */}

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">

        {statsData.map((stat) => (
          <StatCard
            key={stat.id}
            icon={stat.icon}
            title={stat.title}
            value={stat.value}
            arrowColor={stat.arrowColor}
            link={stat.link}   // ✅ add this
            onclick={stat.onclick}
            setState={setOpenFeedBackform}
          />
        ))}
        <FeedbackForm openFeedBackForm={openFeedBackForm} setOpenFeedBackform={setOpenFeedBackform} />

      </div>
      <div className="card">
        <div className="grid md:grid-cols-2 gap-6  ">
          <div className='p-4'>

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-[#717576] ">
                Performance Trend
              </h2>
              {/* <select
                className="border rounded-lg px-3 py-2 text-sm text-gray-600 focus:outline-none focus:ring-0"
              >
                <option>Last 30 days</option>
                <option>Last 60 days</option>
                <option>Last 90 days</option>
              </select> */}

            </div>
            <ClassPerformanceTwoLineChart data={dashboardPerformanceTrend} />
          </div>
          <div className='p-4'>
            <h2 className="text-lg font-semibold mb-4">Milestone Completion</h2>
            <MilestoneCompletion milestones={dashboardPerformanceSummary} loader={loader}/>
          </div>

        </div>
      </div>


      <div className="card p-4">
        <h2 className="text-md  mb-4 text-[#717576]">My Applications</h2>

        <StudentApplicationTable applications={dashboardMyApplications} headers={applicationTableHeaders} loader={loader}/>


      </div>


      {/* Recent Applications */}
      {/* <div className="card">
        <div className="card-header">
          <h3 className="text-lg font-medium text-gray-900">Recent Applications</h3>
        </div>
        <div className="card-body">
          <div className="space-y-4">
            {[
              { name: 'Math Explorer', progress: 75, lastUsed: '2 hours ago' },
              { name: 'Reading Adventures', progress: 100, lastUsed: '1 day ago' },
              { name: 'Science Lab Virtual', progress: 45, lastUsed: '3 days ago' }
            ].map((app) => (
              <div key={app.name} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div>
                  <h4 className="font-medium text-gray-900">{app.name}</h4>
                  <p className="text-sm text-gray-600">Last used {app.lastUsed}</p>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-gray-900">{app.progress}%</div>
                  <div className="w-20 bg-gray-200 rounded-full h-2 mt-1">
                    <div
                      className="bg-primary-600 h-2 rounded-full"
                      style={{ width: `${app.progress}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default StudentDashboard